var _defs, _path, _path2, _text, _path3, _path4, _text2, _path5, _path6, _text3, _path7, _path8, _text4, _path9, _path10, _text5, _path11, _path12, _path13, _path14, _font, _text6, _path15, _path16, _font2, _text7, _path17, _path18, _text8, _path19, _path20, _text9, _path21, _path22, _text10, _path23, _path24, _text11, _path25, _path26, _text12, _path27, _path28, _path29, _path30, _font3, _text13, _path31, _path32, _font4, _text14, _path33, _path34, _rect, _path35, _text15, _rect2, _path36, _text16, _path37, _path38, _rect3, _path39, _font5, _text17, _path40, _path41, _path42, _path43, _font6, _text18, _path44, _path45, _path46, _path47, _font7, _text19, _path48, _font8, _text20, _path49, _path50, _font9, _text21, _path51, _path52, _font10, _text22, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "979px",
    height: "621px",
    viewBox: "-0.5 -0.5 979 621",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2023-12-30T23:12:03.948Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36\" etag=\"qryCmF9w-LEJajPU5M37\" version=\"22.1.16\" type=\"device\"> <diagram name=\"Page-1\" id=\"5NGbAuT3B4IR13jzINcZ\"> <mxGraphModel dx=\"2284\" dy=\"765\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"850\" pageHeight=\"1100\" background=\"none\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-8\" value=\"AWS Cloud\" style=\"points=[[0,0],[0.25,0],[0.5,0],[0.75,0],[1,0],[1,0.25],[1,0.5],[1,0.75],[1,1],[0.75,1],[0.5,1],[0.25,1],[0,1],[0,0.75],[0,0.5],[0,0.25]];outlineConnect=0;html=1;whiteSpace=wrap;fontSize=12;fontStyle=0;container=1;pointerEvents=0;collapsible=0;recursiveResize=0;shape=mxgraph.aws4.group;grIcon=mxgraph.aws4.group_aws_cloud_alt;fillColor=none;verticalAlign=top;align=left;spacingLeft=30;dashed=0;labelBackgroundColor=none;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"120\" y=\"160\" width=\"650\" height=\"520\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-11\" value=\"Region\" style=\"points=[[0,0],[0.25,0],[0.5,0],[0.75,0],[1,0],[1,0.25],[1,0.5],[1,0.75],[1,1],[0.75,1],[0.5,1],[0.25,1],[0,1],[0,0.75],[0,0.5],[0,0.25]];outlineConnect=0;gradientColor=none;html=1;whiteSpace=wrap;fontSize=12;fontStyle=0;container=1;pointerEvents=0;collapsible=0;recursiveResize=0;shape=mxgraph.aws4.group;grIcon=mxgraph.aws4.group_region;strokeColor=#00A4A6;fillColor=none;verticalAlign=top;align=left;spacingLeft=30;fontColor=#147EBA;dashed=1;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"160\" y=\"100\" width=\"320\" height=\"380\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-18\" value=\"Amazon S3\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#7AA116;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.s3;\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" vertex=\"1\"> <mxGeometry x=\"40\" y=\"60\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-19\" value=\"Amazon API Gateway\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#E7157B;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.api_gateway;\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" vertex=\"1\"> <mxGeometry x=\"40\" y=\"270\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-26\" value=\"Amazon Lambda\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#ED7100;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.lambda;\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" vertex=\"1\"> <mxGeometry x=\"210\" y=\"270\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-39\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" source=\"NAXNjwD0Ikc25tdS_HBy-19\" target=\"NAXNjwD0Ikc25tdS_HBy-26\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-54\" value=\"&lt;font color=&quot;#000000&quot;&gt;Amazon DynamoDB&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fillColor=#0000FF;strokeColor=#FFFFFF;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.dynamodb;fontColor=#ffffff;\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" vertex=\"1\"> <mxGeometry x=\"210\" y=\"60\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-55\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=1;entryDx=0;entryDy=0;entryPerimeter=0;strokeColor=#000000;fontColor=#FEFAE0;fillColor=#BC6C25;exitX=0.5;exitY=0;exitDx=0;exitDy=0;exitPerimeter=0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-11\" source=\"NAXNjwD0Ikc25tdS_HBy-26\" target=\"NAXNjwD0Ikc25tdS_HBy-54\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-60\" value=\"&lt;font color=&quot;#000000&quot;&gt;store message&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-55\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.082\" y=\"1\" relative=\"1\" as=\"geometry\"> <mxPoint y=\"-1\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-20\" value=\"Amazon Route 53\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#8C4FFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.route_53;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"40\" y=\"80\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-24\" value=\"Amazon CloudWatch\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#E7157B;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.cloudwatch_2;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"550\" y=\"220\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-25\" value=\"IAM\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#DD344C;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.identity_and_access_management;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"550\" y=\"70\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-29\" value=\"Amazon SES\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#DD344C;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.simple_email_service;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"550\" y=\"370\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-17\" value=\"Amazon CloudFront\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;fillColor=#8C4FFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.cloudfront;\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" vertex=\"1\"> <mxGeometry x=\"40\" y=\"260.5\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-37\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;exitX=0.5;exitY=0;exitDx=0;exitDy=0;exitPerimeter=0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" source=\"NAXNjwD0Ikc25tdS_HBy-17\" target=\"NAXNjwD0Ikc25tdS_HBy-18\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-38\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;exitX=0.5;exitY=1;exitDx=0;exitDy=0;exitPerimeter=0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" source=\"NAXNjwD0Ikc25tdS_HBy-17\" target=\"NAXNjwD0Ikc25tdS_HBy-19\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-63\" value=\"&lt;font color=&quot;#000000&quot;&gt;send a message&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-38\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.0724\" y=\"-2\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"223\" y=\"-11\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-40\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-8\" source=\"NAXNjwD0Ikc25tdS_HBy-26\" target=\"NAXNjwD0Ikc25tdS_HBy-29\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-59\" value=\"&lt;font color=&quot;#000000&quot;&gt;send message&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-40\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.2168\" y=\"1\" relative=\"1\" as=\"geometry\"> <mxPoint y=\"-8\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-30\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#FEFAE0;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-21\" target=\"NAXNjwD0Ikc25tdS_HBy-22\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-21\" value=\"Users\" style=\"sketch=0;outlineConnect=0;fontColor=#232F3E;gradientColor=none;fillColor=#232F3D;strokeColor=none;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;pointerEvents=1;shape=mxgraph.aws4.users;\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"-200\" y=\"240\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-22\" value=\"Devices\" style=\"sketch=0;outlineConnect=0;gradientColor=none;fontColor=#545B64;strokeColor=none;fillColor=#000000;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.illustration_devices;pointerEvents=1\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"-208.26\" y=\"425\" width=\"94.52\" height=\"69\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-23\" value=\"&lt;font color=&quot;#232f3e&quot;&gt;Public Internet&lt;/font&gt;\" style=\"outlineConnect=0;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;shape=mxgraph.aws3.internet_2;fillColor=#0050ef;strokeColor=#001DBC;fontColor=#ffffff;fontStyle=0\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"-20\" y=\"432.5\" width=\"79.5\" height=\"54\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-32\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;fontColor=#FEFAE0;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-22\" target=\"NAXNjwD0Ikc25tdS_HBy-23\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-34\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;exitX=0.38;exitY=0.025;exitDx=0;exitDy=0;exitPerimeter=0;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-23\" target=\"NAXNjwD0Ikc25tdS_HBy-20\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"10\" y=\"280\" /> <mxPoint x=\"110\" y=\"280\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-62\" value=\"&lt;font color=&quot;#0000ff&quot;&gt;api.domenic-aws.info&lt;br&gt;www.domenic-aws.info&lt;br&gt;domenic-aws.info&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-34\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.3742\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"-70\" y=\"80\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-36\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;fontColor=#FEFAE0;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-23\" target=\"NAXNjwD0Ikc25tdS_HBy-17\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-46\" value=\"&lt;font color=&quot;#000000&quot;&gt;Github&lt;/font&gt;\" style=\"dashed=0;outlineConnect=0;html=1;align=center;labelPosition=center;verticalLabelPosition=bottom;verticalAlign=top;shape=mxgraph.weblogos.github;strokeColor=#DDA15E;fontColor=#FEFAE0;fillColor=#BC6C25;fontStyle=0\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"670\" y=\"60\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-50\" value=\"&lt;font color=&quot;#000000&quot;&gt;Repository&lt;/font&gt;\" style=\"verticalLabelPosition=bottom;html=1;verticalAlign=top;align=center;strokeColor=none;fillColor=#FF9933;shape=mxgraph.azure.git_repository;fontColor=#FEFAE0;fontStyle=0\" parent=\"1\" vertex=\"1\"> <mxGeometry x=\"490\" y=\"60\" width=\"78\" height=\"78\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-53\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;entryPerimeter=0;strokeColor=#000000;fontColor=#FEFAE0;fillColor=#BC6C25;exitX=0;exitY=0.5;exitDx=0;exitDy=0;exitPerimeter=0;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-50\" target=\"NAXNjwD0Ikc25tdS_HBy-18\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-57\" value=\"&lt;font color=&quot;#000000&quot;&gt;AWS S3 sync build&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-53\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"0.4329\" y=\"-2\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"2\" as=\"offset\" /> </mxGeometry> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-65\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=1;entryY=0.5;entryDx=0;entryDy=0;entryPerimeter=0;strokeColor=#000000;fontColor=#FEFAE0;fillColor=#BC6C25;fontStyle=0\" parent=\"1\" source=\"NAXNjwD0Ikc25tdS_HBy-46\" target=\"NAXNjwD0Ikc25tdS_HBy-50\" edge=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"NAXNjwD0Ikc25tdS_HBy-66\" value=\"&lt;font color=&quot;#000000&quot;&gt;ReactJS project&lt;/font&gt;\" style=\"edgeLabel;html=1;align=center;verticalAlign=middle;resizable=0;points=[];fontColor=#FEFAE0;fontStyle=0\" parent=\"NAXNjwD0Ikc25tdS_HBy-65\" vertex=\"1\" connectable=\"0\"> <mxGeometry x=\"-0.0369\" y=\"1\" relative=\"1\" as=\"geometry\"> <mxPoint y=\"10\" as=\"offset\" /> </mxGeometry> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 328 100 L 978 100 L 978 620 L 328 620 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 334.09 107.18 C 334.01 107.18 333.93 107.19 333.85 107.19 C 333.5 107.19 333.15 107.23 332.81 107.32 C 332.53 107.39 332.25 107.49 331.98 107.62 C 331.9 107.65 331.84 107.7 331.79 107.76 C 331.75 107.83 331.74 107.91 331.74 107.99 L 331.74 108.32 C 331.74 108.46 331.79 108.53 331.88 108.53 L 331.99 108.53 L 332.22 108.44 C 332.45 108.35 332.69 108.27 332.94 108.21 C 333.17 108.16 333.41 108.13 333.65 108.13 C 334.04 108.09 334.43 108.2 334.74 108.44 C 334.97 108.74 335.09 109.12 335.05 109.5 L 335.05 109.99 C 334.79 109.93 334.54 109.88 334.29 109.84 C 334.05 109.81 333.81 109.79 333.57 109.79 C 332.98 109.76 332.4 109.94 331.94 110.31 C 331.54 110.65 331.32 111.15 331.34 111.68 C 331.31 112.15 331.49 112.62 331.82 112.96 C 332.18 113.29 332.66 113.46 333.15 113.44 C 333.91 113.45 334.63 113.11 335.11 112.51 C 335.18 112.66 335.24 112.79 335.31 112.91 C 335.38 113.02 335.46 113.12 335.55 113.21 C 335.6 113.27 335.67 113.31 335.75 113.31 C 335.81 113.31 335.87 113.29 335.92 113.25 L 336.34 112.97 C 336.41 112.93 336.46 112.86 336.47 112.77 C 336.47 112.72 336.45 112.67 336.42 112.62 C 336.34 112.47 336.26 112.31 336.21 112.14 C 336.15 111.95 336.12 111.75 336.13 111.55 L 336.14 109.37 C 336.2 108.77 336 108.18 335.59 107.74 C 335.17 107.39 334.64 107.19 334.09 107.18 Z M 347.89 107.19 C 347.78 107.19 347.68 107.19 347.57 107.2 C 347.29 107.2 347 107.24 346.73 107.31 C 346.47 107.38 346.23 107.5 346.01 107.66 C 345.82 107.81 345.66 107.99 345.54 108.21 C 345.42 108.43 345.35 108.67 345.36 108.92 C 345.36 109.27 345.48 109.61 345.69 109.89 C 345.97 110.22 346.34 110.46 346.76 110.56 L 347.72 110.87 C 347.97 110.93 348.2 111.05 348.39 111.22 C 348.51 111.35 348.58 111.51 348.57 111.69 C 348.58 111.94 348.45 112.18 348.23 112.31 C 347.93 112.48 347.6 112.56 347.26 112.54 C 346.99 112.54 346.72 112.51 346.46 112.45 C 346.22 112.4 345.98 112.32 345.75 112.22 L 345.58 112.15 C 345.54 112.14 345.5 112.14 345.46 112.15 C 345.36 112.15 345.31 112.22 345.31 112.36 L 345.31 112.69 C 345.31 112.76 345.32 112.82 345.35 112.89 C 345.4 112.97 345.47 113.03 345.56 113.07 C 345.8 113.19 346.06 113.28 346.32 113.34 C 346.66 113.41 347 113.45 347.35 113.45 L 347.33 113.46 C 347.66 113.45 347.98 113.4 348.29 113.3 C 348.55 113.22 348.8 113.09 349.01 112.92 C 349.21 112.77 349.38 112.57 349.49 112.34 C 349.61 112.1 349.67 111.83 349.66 111.56 C 349.67 111.23 349.56 110.9 349.36 110.63 C 349.09 110.32 348.73 110.09 348.33 109.99 L 347.39 109.69 C 347.13 109.61 346.88 109.49 346.67 109.32 C 346.54 109.2 346.47 109.03 346.47 108.85 C 346.46 108.61 346.58 108.38 346.79 108.25 C 347.06 108.11 347.36 108.05 347.67 108.06 C 348.11 108.06 348.55 108.14 348.96 108.32 C 349.04 108.37 349.12 108.4 349.21 108.41 C 349.31 108.41 349.36 108.34 349.36 108.19 L 349.36 107.88 C 349.37 107.8 349.35 107.72 349.31 107.66 C 349.25 107.59 349.18 107.54 349.11 107.49 L 348.83 107.38 L 348.45 107.27 L 348.01 107.2 C 347.97 107.2 347.93 107.19 347.89 107.19 Z M 344.02 107.36 C 343.94 107.35 343.86 107.38 343.79 107.42 C 343.72 107.5 343.68 107.59 343.66 107.69 L 342.51 112.14 L 341.47 107.71 C 341.45 107.61 341.41 107.52 341.34 107.44 C 341.26 107.39 341.17 107.37 341.07 107.38 L 340.54 107.38 C 340.44 107.37 340.35 107.39 340.27 107.44 C 340.2 107.51 340.15 107.61 340.14 107.71 L 339.09 112.14 L 337.97 107.7 C 337.95 107.6 337.91 107.51 337.84 107.44 C 337.76 107.39 337.67 107.36 337.58 107.37 L 336.92 107.37 C 336.81 107.37 336.76 107.43 336.76 107.54 C 336.77 107.63 336.79 107.72 336.82 107.81 L 338.38 112.95 C 338.4 113.05 338.45 113.14 338.52 113.21 C 338.6 113.26 338.69 113.29 338.78 113.28 L 339.36 113.26 C 339.46 113.27 339.55 113.25 339.63 113.19 C 339.7 113.12 339.74 113.03 339.76 112.93 L 340.79 108.64 L 341.82 112.93 C 341.83 113.03 341.88 113.12 341.95 113.19 C 342.03 113.25 342.12 113.27 342.21 113.26 L 342.79 113.26 C 342.88 113.27 342.97 113.25 343.04 113.2 C 343.11 113.13 343.16 113.03 343.18 112.94 L 344.79 107.79 C 344.84 107.72 344.84 107.63 344.84 107.63 C 344.84 107.59 344.84 107.56 344.84 107.52 C 344.84 107.48 344.82 107.43 344.79 107.4 C 344.76 107.37 344.72 107.35 344.67 107.36 L 344.05 107.36 C 344.04 107.36 344.03 107.36 344.02 107.36 Z M 333.65 110.62 C 333.7 110.62 333.75 110.62 333.8 110.62 L 334.43 110.62 C 334.64 110.64 334.85 110.67 335.06 110.71 L 335.06 111.01 C 335.07 111.21 335.05 111.4 335 111.59 C 334.96 111.75 334.88 111.9 334.77 112.01 C 334.61 112.21 334.39 112.36 334.14 112.44 C 333.91 112.52 333.67 112.56 333.43 112.56 C 333.18 112.6 332.93 112.53 332.73 112.37 C 332.55 112.18 332.46 111.92 332.49 111.66 C 332.47 111.36 332.59 111.08 332.81 110.89 C 333.06 110.72 333.35 110.62 333.65 110.62 Z M 349.04 114.72 C 348.34 114.73 347.51 114.89 346.88 115.33 C 346.69 115.47 346.72 115.63 346.94 115.63 C 347.64 115.54 349.21 115.35 349.5 115.71 C 349.78 116.06 349.19 117.54 348.94 118.21 C 348.86 118.41 349.04 118.49 349.21 118.34 C 350.39 117.36 350.72 115.3 350.46 115 C 350.32 114.85 349.74 114.71 349.04 114.72 Z M 330.65 115.1 C 330.5 115.12 330.42 115.3 330.58 115.44 C 333.29 117.89 336.82 119.23 340.48 119.21 C 343.37 119.22 346.2 118.36 348.59 116.74 C 348.95 116.47 348.63 116.07 348.26 116.23 C 345.87 117.24 343.3 117.76 340.71 117.77 C 337.23 117.78 333.82 116.87 330.81 115.14 C 330.75 115.11 330.69 115.1 330.65 115.1 Z M 328 100 L 353 100 L 353 125 L 328 125 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 618,
      height: 1,
      paddingTop: 107,
      marginLeft: 360
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 119,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 488 200 L 808 200 L 808 580 L 488 580 Z",
    fill: "none",
    stroke: "#00a4a6",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 496.06 203.47 C 495.47 203.47 495 203.95 495 204.53 C 495 204.99 495.3 205.39 495.71 205.53 L 495.71 220.82 L 493.95 220.82 L 493.95 221.57 L 498.16 221.57 L 498.16 220.82 L 496.46 220.82 L 496.46 212.75 L 507.84 212.75 L 505.19 209.59 L 507.83 206.36 L 496.46 206.36 L 496.46 205.51 C 496.85 205.35 497.12 204.97 497.12 204.53 C 497.12 203.95 496.64 203.47 496.06 203.47 Z M 496.06 204.22 C 496.23 204.22 496.37 204.35 496.37 204.53 C 496.37 204.71 496.23 204.84 496.06 204.84 C 495.88 204.84 495.75 204.71 495.75 204.53 C 495.75 204.35 495.88 204.22 496.06 204.22 Z M 496.46 207.11 L 506.25 207.11 L 504.22 209.6 L 506.23 212 L 496.46 212 Z M 488 225 L 488 200 L 513 200 L 513 225 Z",
    fill: "#00a4a6",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 288,
      height: 1,
      paddingTop: 207,
      marginLeft: 520
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #147EBA; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(20, 126, 186)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Region")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 219,
    fill: "#147EBA",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Region")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 528 260 L 606 260 L 606 338 L 528 338 Z",
    fill: "#7aa116",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 590.28 302.22 L 590.71 299.21 C 594.66 301.57 594.71 302.55 594.71 302.58 C 594.7 302.58 594.03 303.14 590.28 302.22 Z M 588.12 301.62 C 581.3 299.56 571.8 295.2 567.96 293.39 C 567.96 293.37 567.96 293.36 567.96 293.34 C 567.96 291.86 566.76 290.66 565.28 290.66 C 563.81 290.66 562.61 291.86 562.61 293.34 C 562.61 294.82 563.81 296.02 565.28 296.02 C 565.93 296.02 566.52 295.78 566.98 295.39 C 571.51 297.53 580.93 301.82 587.8 303.85 L 585.08 323.03 C 585.07 323.08 585.07 323.13 585.07 323.18 C 585.07 324.87 577.6 327.97 565.39 327.97 C 553.05 327.97 545.49 324.87 545.49 323.18 C 545.49 323.13 545.49 323.08 545.48 323.03 L 539.81 281.57 C 544.72 284.95 555.29 286.74 565.39 286.74 C 575.48 286.74 586.03 284.96 590.96 281.59 Z M 539.21 277.25 C 539.29 275.78 547.71 270.03 565.39 270.03 C 583.07 270.03 591.5 275.78 591.58 277.25 L 591.58 277.75 C 590.61 281.04 579.69 284.51 565.39 284.51 C 551.07 284.51 540.15 281.02 539.21 277.73 Z M 593.81 277.27 C 593.81 273.41 582.74 267.8 565.39 267.8 C 548.05 267.8 536.98 273.41 536.98 277.27 L 537.08 278.11 L 543.27 323.27 C 543.41 328.32 556.88 330.2 565.39 330.2 C 575.94 330.2 587.15 327.77 587.3 323.27 L 589.97 304.44 C 591.45 304.8 592.68 304.98 593.66 304.98 C 594.98 304.98 595.87 304.66 596.41 304.01 C 596.85 303.49 597.02 302.85 596.89 302.16 C 596.61 300.62 594.77 298.96 591.05 296.83 L 593.69 278.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 345,
      marginLeft: 567
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon S3")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 567,
    y: 357,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon S3")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 528 470 L 606 470 L 606 548 L 528 548 Z",
    fill: "#e7157b",
    stroke: "none",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 560.39 526.43 L 563.66 526.43 L 563.66 524.19 L 560.39 524.19 Z M 565.89 526.43 L 569.23 526.43 L 569.23 524.19 L 565.89 524.19 Z M 552.53 480.78 L 538.05 487.97 L 538.05 532.62 L 552.53 537.52 Z M 554.75 494.99 L 554.75 524.19 L 558.09 524.19 L 558.09 526.43 L 554.75 526.43 L 554.75 539.08 C 554.75 539.44 554.58 539.78 554.29 539.99 C 554.1 540.13 553.87 540.2 553.64 540.2 C 553.52 540.2 553.4 540.18 553.29 540.14 L 536.59 534.5 C 536.13 534.34 535.83 533.91 535.83 533.43 L 535.83 487.27 C 535.83 486.84 536.07 486.45 536.45 486.26 L 553.15 477.97 C 553.49 477.8 553.9 477.82 554.23 478.03 C 554.55 478.23 554.75 478.59 554.75 478.98 L 554.75 492.75 L 558.09 492.75 L 558.09 494.99 Z M 571.45 526.43 L 574.79 526.43 L 574.79 524.19 L 571.45 524.19 Z M 571.53 494.99 L 574.79 494.99 L 574.79 492.75 L 571.53 492.75 Z M 565.96 494.99 L 569.23 494.99 L 569.23 492.75 L 565.96 492.75 Z M 560.39 494.99 L 563.66 494.99 L 563.66 492.75 L 560.39 492.75 Z M 595.95 487.97 L 581.47 480.78 L 581.47 537.52 L 595.95 532.62 Z M 598.17 533.43 C 598.17 533.91 597.87 534.34 597.41 534.5 L 580.71 540.14 C 580.6 540.18 580.48 540.2 580.36 540.2 C 580.13 540.2 579.9 540.13 579.71 539.99 C 579.42 539.78 579.25 539.44 579.25 539.08 L 579.25 526.43 L 577.09 526.43 L 577.09 524.19 L 579.25 524.19 L 579.25 494.99 L 577.09 494.99 L 577.09 492.75 L 579.25 492.75 L 579.25 478.98 C 579.25 478.59 579.45 478.23 579.77 478.03 C 580.1 477.82 580.51 477.8 580.85 477.97 L 597.55 486.26 C 597.93 486.45 598.17 486.84 598.17 487.27 Z M 570.27 502.13 L 568.19 501.33 L 562.62 515.92 L 564.7 516.73 Z M 577.81 509.26 C 578.24 508.82 578.24 508.11 577.81 507.67 L 573.35 503.18 L 571.78 504.77 L 575.45 508.47 L 571.78 512.16 L 573.35 513.75 Z M 560.65 513.75 L 556.19 509.26 C 555.76 508.82 555.76 508.11 556.19 507.67 L 560.65 503.18 L 562.22 504.77 L 558.55 508.47 L 562.22 512.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 555,
      marginLeft: 567
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon API Gateway")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 567,
    y: 567,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon API Ga...")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 698 470 L 776 470 L 776 548 L 698 548 Z",
    fill: "#ed7100",
    stroke: "none",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 723.67 537.97 L 709.83 537.97 L 725.13 505.99 L 732.06 520.26 Z M 726.13 502.93 C 725.94 502.55 725.55 502.3 725.13 502.3 L 725.12 502.3 C 724.69 502.3 724.3 502.55 724.12 502.94 L 707.05 538.61 C 706.89 538.95 706.91 539.36 707.11 539.68 C 707.32 540 707.68 540.2 708.06 540.2 L 724.37 540.2 C 724.8 540.2 725.2 539.95 725.38 539.56 L 734.31 520.73 C 734.46 520.43 734.46 520.07 734.31 519.77 Z M 764.88 537.97 L 751.13 537.97 L 729.08 491.81 C 728.9 491.42 728.5 491.17 728.07 491.17 L 719.08 491.17 L 719.09 480.03 L 736.72 480.03 L 758.67 526.19 C 758.85 526.58 759.25 526.83 759.68 526.83 L 764.88 526.83 Z M 766 524.6 L 760.38 524.6 L 738.43 478.44 C 738.25 478.05 737.85 477.8 737.42 477.8 L 717.97 477.8 C 717.36 477.8 716.86 478.3 716.85 478.91 L 716.84 492.28 C 716.84 492.58 716.96 492.86 717.17 493.07 C 717.38 493.28 717.66 493.4 717.96 493.4 L 727.37 493.4 L 749.42 539.56 C 749.61 539.95 750 540.2 750.43 540.2 L 766 540.2 C 766.61 540.2 767.11 539.7 767.11 539.09 L 767.11 525.71 C 767.11 525.1 766.61 524.6 766 524.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 555,
      marginLeft: 737
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon Lambda")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 567,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon Lambda")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 606 509 L 691.63 509",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 696.88 509 L 689.88 512.5 L 691.63 509 L 689.88 505.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 698 260 L 776 260 L 776 338 L 698 338 Z",
    fill: "#0000ff",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 750.42 315.55 C 746.7 318.55 738.9 320.14 731.43 320.14 C 723.97 320.14 716.16 318.55 712.44 315.55 L 712.44 321.6 L 712.44 321.6 C 712.44 324.62 720.24 327.99 731.43 327.99 C 742.62 327.99 750.41 324.63 750.42 321.61 Z M 750.43 304.04 L 752.65 304.03 L 752.65 304.04 C 752.65 305.38 751.98 306.64 750.67 307.79 C 752.26 309.19 752.65 310.57 752.65 311.54 C 752.65 311.55 752.65 311.56 752.65 311.56 L 752.65 321.6 L 752.65 321.6 C 752.65 327.19 741.72 330.2 731.43 330.2 C 721.17 330.2 710.27 327.2 710.22 321.64 C 710.22 321.64 710.21 321.63 710.21 321.62 L 710.21 311.54 C 710.21 311.54 710.22 311.54 710.22 311.53 C 710.22 310.55 710.62 309.19 712.21 307.79 C 710.63 306.39 710.23 305.03 710.22 304.06 L 710.22 304.06 C 710.22 304.06 710.21 304.06 710.21 304.05 L 710.21 293.97 C 710.21 293.96 710.22 293.96 710.22 293.96 C 710.22 292.98 710.62 291.61 712.21 290.22 C 710.63 288.82 710.23 287.46 710.22 286.49 L 710.22 286.49 C 710.22 286.49 710.21 286.48 710.21 286.48 L 710.21 276.39 C 710.21 276.39 710.22 276.39 710.22 276.38 C 710.24 270.81 721.16 267.8 731.43 267.8 C 737.24 267.8 742.82 268.72 746.74 270.33 L 745.89 272.37 C 742.23 270.87 736.96 270.01 731.43 270.01 C 720.24 270.01 712.44 273.38 712.44 276.4 C 712.44 279.42 720.24 282.79 731.43 282.79 C 731.74 282.79 732.03 282.79 732.33 282.78 L 732.42 284.98 C 732.09 285 731.76 285 731.43 285 C 723.97 285 716.16 283.41 712.44 280.4 L 712.44 286.45 L 712.44 286.45 L 712.44 286.48 C 712.46 287.64 713.64 288.65 714.64 289.29 C 717.64 291.2 723.01 292.51 729 292.78 L 728.9 294.99 C 722.83 294.71 717.52 293.45 714.1 291.53 C 713.25 292.15 712.44 293.01 712.44 293.97 C 712.44 296.99 720.24 300.36 731.43 300.36 C 732.53 300.36 733.62 300.32 734.68 300.25 L 734.83 302.46 C 733.73 302.53 732.58 302.57 731.43 302.57 C 723.97 302.57 716.16 300.98 712.44 297.97 L 712.44 304.03 L 712.44 304.03 C 712.46 305.21 713.64 306.22 714.64 306.87 C 718.07 309.05 724.5 310.42 731.43 310.42 L 731.92 310.42 L 731.92 312.63 L 731.43 312.63 C 724.39 312.63 717.99 311.32 714.08 309.11 C 713.24 309.74 712.44 310.59 712.44 311.54 C 712.44 314.57 720.24 317.93 731.43 317.93 C 742.62 317.93 750.41 314.57 750.42 311.55 L 750.42 311.54 L 750.42 311.54 C 750.42 310.58 749.62 309.73 748.78 309.1 C 748.24 309.41 747.65 309.71 746.99 309.98 L 746.14 307.94 C 746.95 307.61 747.65 307.25 748.22 306.87 C 749.23 306.21 750.43 305.19 750.43 304.04 Z M 759.97 287.88 L 753.73 287.88 C 753.36 287.88 753.01 287.69 752.8 287.39 C 752.6 287.09 752.55 286.7 752.69 286.36 L 756.49 276.87 L 742.1 276.87 L 735.42 290.13 L 742.53 290.13 C 742.89 290.13 743.22 290.3 743.43 290.58 C 743.64 290.87 743.7 291.23 743.59 291.57 L 737.24 311.36 Z M 763.39 287.54 L 735.53 316.32 C 735.32 316.54 735.02 316.65 734.73 316.65 C 734.53 316.65 734.34 316.6 734.16 316.5 C 733.71 316.24 733.51 315.71 733.67 315.22 L 741.01 292.34 L 733.62 292.34 C 733.23 292.34 732.87 292.14 732.67 291.82 C 732.46 291.49 732.45 291.08 732.62 290.74 L 740.42 275.27 C 740.61 274.89 740.99 274.66 741.42 274.66 L 758.13 274.66 C 758.5 274.66 758.85 274.84 759.05 275.14 C 759.26 275.45 759.3 275.83 759.17 276.17 L 755.37 285.67 L 762.59 285.67 C 763.03 285.67 763.44 285.93 763.61 286.34 C 763.79 286.75 763.7 287.22 763.39 287.54 Z M 714.06 322.04 C 715.64 322.93 717.63 323.67 719.97 324.26 L 720.52 322.11 C 718.4 321.59 716.55 320.9 715.17 320.12 Z M 719.97 306.58 L 720.52 304.43 C 718.4 303.9 716.55 303.21 715.17 302.43 L 714.06 304.35 C 715.64 305.24 717.63 305.99 719.97 306.58 Z M 714.06 286.67 L 715.17 284.75 C 716.55 285.53 718.4 286.22 720.52 286.75 L 719.97 288.89 C 717.63 288.31 715.64 287.56 714.06 286.67 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 345,
      marginLeft: 737
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "Amazon DynamoDB")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 357,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon Dynamo...")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 737 470 L 737 344.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 737 339.12 L 740.5 346.12 L 737 344.37 L 733.5 346.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 409,
      marginLeft: 737
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "store message")))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 412,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "store message")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 368 180 L 446 180 L 446 258 L 368 258 Z",
    fill: "#8c4fff",
    stroke: "none",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 416.66 219.82 C 417.49 220.58 417.9 221.6 417.9 222.88 C 417.9 224.27 417.4 225.38 416.4 226.21 C 415.4 227.04 414.05 227.46 412.37 227.46 C 411.03 227.46 409.71 227.17 408.41 226.6 L 408.41 224.9 C 409.95 225.41 411.27 225.67 412.37 225.67 C 413.44 225.67 414.27 225.43 414.86 224.94 C 415.44 224.46 415.73 223.77 415.73 222.88 C 415.73 221.16 414.64 220.3 412.47 220.3 C 411.79 220.3 411.12 220.34 410.45 220.41 L 410.45 219.01 L 414.92 214.13 L 408.62 214.13 L 408.62 212.38 L 417.28 212.38 L 417.28 214.07 L 412.9 218.71 C 412.97 218.69 413.04 218.69 413.11 218.69 L 413.32 218.69 C 414.73 218.69 415.84 219.07 416.66 219.82 M 404.3 219.45 C 405.17 220.26 405.6 221.37 405.6 222.79 C 405.6 224.18 405.1 225.31 404.09 226.17 C 403.08 227.03 401.76 227.46 400.11 227.46 C 398.66 227.46 397.31 227.17 396.05 226.6 L 396.05 224.9 C 397.62 225.41 398.97 225.67 400.09 225.67 C 401.17 225.67 401.99 225.42 402.57 224.93 C 403.14 224.44 403.43 223.74 403.43 222.81 C 403.43 221.81 403.16 221.08 402.62 220.62 C 402.08 220.17 401.2 219.94 399.98 219.94 C 399.1 219.94 398 220.01 396.68 220.15 L 396.68 218.75 L 397.09 212.38 L 404.86 212.38 L 404.86 214.13 L 398.88 214.13 L 398.6 218.45 C 399.38 218.31 400.08 218.24 400.7 218.24 C 402.24 218.24 403.44 218.64 404.3 219.45 M 420.29 235.05 C 414.9 236.02 410.17 238.22 407 240.01 C 403.83 238.22 399.1 236.02 393.71 235.05 C 392.19 234.78 384.62 233.2 384.62 228.83 C 384.62 226.8 385.34 225.45 386.74 223.05 C 388.4 220.18 390.48 216.61 390.48 211.46 C 390.48 207.78 389.51 204.25 387.61 200.96 C 387.83 200.69 388.06 200.41 388.29 200.13 C 391.11 201.54 394.04 202.25 397.03 202.25 C 400.67 202.25 404.03 201.29 407 199.4 C 409.97 201.29 413.32 202.25 416.97 202.25 C 419.95 202.25 422.89 201.54 425.71 200.13 C 425.94 200.41 426.17 200.69 426.39 200.96 C 424.49 204.25 423.52 207.78 423.52 211.46 C 423.52 216.61 425.6 220.18 427.26 223.06 C 428.65 225.45 429.38 226.8 429.38 228.83 C 429.38 233.2 421.81 234.78 420.29 235.05 M 425.75 211.46 C 425.75 207.95 426.74 204.58 428.69 201.46 C 428.94 201.05 428.91 200.53 428.61 200.16 C 428.04 199.47 427.45 198.74 426.86 198.02 C 426.53 197.6 425.94 197.48 425.46 197.74 C 422.72 199.26 419.87 200.02 416.97 200.02 C 413.48 200.02 410.42 199.09 407.63 197.15 C 407.25 196.89 406.75 196.89 406.37 197.15 C 403.58 199.09 400.52 200.02 397.03 200.02 C 394.13 200.02 391.27 199.26 388.54 197.74 C 388.06 197.48 387.47 197.6 387.13 198.02 C 386.55 198.74 385.96 199.47 385.39 200.16 C 385.09 200.53 385.06 201.05 385.31 201.46 C 387.26 204.58 388.25 207.95 388.25 211.46 C 388.25 216.01 386.35 219.29 384.81 221.94 C 383.31 224.52 382.39 226.24 382.39 228.83 C 382.39 234.82 390.75 236.78 393.31 237.24 C 398.72 238.21 403.43 240.5 406.44 242.25 C 406.61 242.36 406.81 242.41 407 242.41 C 407.19 242.41 407.39 242.36 407.56 242.25 C 410.57 240.5 415.28 238.21 420.69 237.24 C 423.25 236.78 431.6 234.82 431.6 228.83 C 431.6 226.24 430.69 224.52 429.19 221.94 C 427.65 219.29 425.75 216.01 425.75 211.46 M 421.45 241.48 C 414.63 242.71 408.92 246.37 407 247.71 C 405.08 246.37 399.37 242.71 392.55 241.48 C 379.13 239.07 378.09 231.18 378.09 228.83 C 378.09 224.94 379.62 222.32 381.09 219.78 C 382.5 217.36 383.95 214.85 383.95 211.46 C 383.95 206.1 380.86 202.31 379.33 200.77 C 380.93 198.82 384.99 193.88 386.99 191.3 C 390.02 194.16 393.54 195.72 397.03 195.72 C 400.89 195.72 404.09 194.15 407 190.79 C 409.91 194.15 413.1 195.72 416.97 195.72 C 420.45 195.72 423.98 194.16 427.01 191.3 C 429.01 193.88 433.06 198.82 434.67 200.77 C 433.14 202.31 430.05 206.1 430.05 211.46 C 430.05 214.85 431.5 217.36 432.91 219.78 C 434.38 222.32 435.91 224.94 435.91 228.83 C 435.91 231.18 434.86 239.07 421.45 241.48 M 434.83 218.66 C 433.46 216.29 432.27 214.25 432.27 211.46 C 432.27 205.58 436.85 201.78 436.89 201.74 C 437.12 201.55 437.27 201.28 437.3 200.99 C 437.33 200.69 437.24 200.4 437.05 200.17 C 436.98 200.08 429.69 191.24 428.02 188.95 C 427.82 188.69 427.52 188.52 427.19 188.5 C 426.86 188.47 426.54 188.61 426.31 188.85 C 423.51 191.84 420.19 193.5 416.97 193.5 C 413.41 193.5 410.61 191.91 407.88 188.35 C 407.46 187.8 406.54 187.8 406.12 188.35 C 403.39 191.91 400.59 193.5 397.03 193.5 C 393.81 193.5 390.49 191.84 387.69 188.85 C 387.46 188.61 387.14 188.47 386.81 188.5 C 386.48 188.52 386.17 188.69 385.98 188.95 C 384.31 191.24 377.02 200.08 376.95 200.17 C 376.76 200.4 376.67 200.69 376.7 200.99 C 376.73 201.28 376.87 201.55 377.1 201.74 C 377.15 201.78 381.73 205.58 381.73 211.46 C 381.73 214.25 380.54 216.29 379.17 218.66 C 377.62 221.33 375.87 224.35 375.87 228.83 C 375.87 236.29 381.96 241.84 392.16 243.67 C 399.84 245.05 406.26 249.92 406.32 249.97 C 406.52 250.12 406.76 250.2 407 250.2 C 407.24 250.2 407.48 250.12 407.68 249.97 C 407.74 249.92 414.14 245.05 421.84 243.67 C 432.04 241.84 438.13 236.29 438.13 228.83 C 438.13 224.35 436.38 221.33 434.83 218.66",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 407
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon Route 53")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 407,
    y: 277,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon Route...")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 878 320 L 956 320 L 956 398 L 878 398 Z",
    fill: "#e7157b",
    stroke: "none",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 933.45 367.15 C 933.45 362.83 929.91 359.31 925.55 359.31 C 921.2 359.31 917.65 362.83 917.65 367.15 C 917.65 371.48 921.2 375 925.55 375 C 929.91 375 933.45 371.48 933.45 367.15 M 935.67 367.15 C 935.67 372.7 931.13 377.21 925.55 377.21 C 919.97 377.21 915.43 372.7 915.43 367.15 C 915.43 361.61 919.97 357.1 925.55 357.1 C 931.13 357.1 935.67 361.61 935.67 367.15 M 945.01 382.31 L 937.26 375.37 C 936.63 376.25 935.91 377.05 935.1 377.76 L 942.85 384.7 C 943.51 385.29 944.54 385.24 945.13 384.58 C 945.73 383.93 945.67 382.91 945.01 382.31 M 925.55 379.2 C 932.24 379.2 937.68 373.8 937.68 367.15 C 937.68 360.51 932.24 355.11 925.55 355.11 C 918.87 355.11 913.43 360.51 913.43 367.15 C 913.43 373.8 918.87 379.2 925.55 379.2 M 946.79 386.06 C 946.03 386.9 944.98 387.32 943.93 387.32 C 943.01 387.32 942.09 387 941.36 386.34 L 933.31 379.13 C 931.07 380.57 928.41 381.41 925.55 381.41 C 917.64 381.41 911.2 375.01 911.2 367.15 C 911.2 359.3 917.64 352.9 925.55 352.9 C 933.46 352.9 939.9 359.3 939.9 367.15 C 939.9 369.41 939.36 371.54 938.41 373.43 L 946.5 380.67 C 948.07 382.08 948.2 384.5 946.79 386.06 M 896.07 347.92 C 896.07 348.49 896.1 349.06 896.17 349.62 C 896.21 349.93 896.11 350.25 895.9 350.49 C 895.73 350.67 895.51 350.8 895.26 350.84 C 892.53 351.54 888.02 353.67 888.02 360.04 C 888.02 364.85 890.7 367.5 892.94 368.89 C 893.7 369.36 894.61 369.62 895.56 369.63 L 908.98 369.64 L 908.98 371.85 L 895.55 371.84 C 894.17 371.83 892.86 371.45 891.76 370.76 C 889.54 369.39 885.8 366.17 885.8 360.04 C 885.8 352.64 890.89 349.91 893.88 348.94 C 893.86 348.6 893.84 348.26 893.84 347.92 C 893.84 341.88 897.97 335.61 903.44 333.34 C 909.84 330.68 916.62 332 921.57 336.87 C 923.11 338.38 924.37 340.22 925.34 342.34 C 926.64 341.26 928.24 340.67 929.93 340.67 C 933.26 340.67 937 343.18 937.66 348.66 C 940.77 349.37 947.35 351.86 947.35 360.12 C 947.35 363.42 946.31 366.15 944.25 368.22 L 942.67 366.67 C 944.3 365.03 945.12 362.82 945.12 360.12 C 945.12 352.9 939.03 351.1 936.41 350.66 C 936.11 350.61 935.85 350.44 935.68 350.2 C 935.51 349.96 935.45 349.66 935.5 349.38 C 935.14 344.89 932.45 342.88 929.93 342.88 C 928.34 342.88 926.85 343.65 925.84 344.99 C 925.6 345.32 925.2 345.48 924.79 345.43 C 924.39 345.37 924.05 345.09 923.91 344.71 C 923 342.2 921.68 340.09 920.01 338.44 C 915.71 334.22 909.84 333.08 904.3 335.38 C 899.68 337.29 896.07 342.8 896.07 347.92",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 405,
      marginLeft: 917
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon CloudWatch")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 917,
    y: 417,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon CloudW...")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 878 170 L 956 170 L 956 248 L 878 248 Z",
    fill: "#dd344c",
    stroke: "none",
    pointerEvents: "all"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 888.03 230.17 L 945.97 230.17 L 945.97 187.83 L 888.03 187.83 Z M 948.2 186.71 L 948.2 231.29 C 948.2 231.9 947.7 232.4 947.09 232.4 L 886.91 232.4 C 886.3 232.4 885.8 231.9 885.8 231.29 L 885.8 186.71 C 885.8 186.1 886.3 185.6 886.91 185.6 L 947.09 185.6 C 947.7 185.6 948.2 186.1 948.2 186.71 Z M 921.46 217.91 L 938.17 217.91 L 938.17 215.69 L 921.46 215.69 Z M 935.94 211.23 L 941.51 211.23 L 941.51 209 L 935.94 209 Z M 921.46 211.23 L 930.37 211.23 L 930.37 209 L 921.46 209 Z M 904.74 215.69 C 904.74 215.07 904.24 214.57 903.63 214.57 C 903.01 214.57 902.51 215.07 902.51 215.69 C 902.51 216.3 903.01 216.8 903.63 216.8 C 904.24 216.8 904.74 216.3 904.74 215.69 Z M 906.97 215.69 C 906.97 217.14 906.04 218.36 904.74 218.82 L 904.74 221.26 L 902.51 221.26 L 902.51 218.82 C 901.22 218.36 900.29 217.14 900.29 215.69 C 900.29 213.84 901.79 212.34 903.63 212.34 C 905.47 212.34 906.97 213.84 906.97 215.69 Z M 893.6 224.59 L 913.65 224.6 L 913.65 220.14 L 909.2 220.14 L 909.2 217.91 L 913.65 217.91 L 913.65 214.57 L 909.2 214.57 L 909.2 212.34 L 913.66 212.34 L 913.66 209.01 L 893.61 209 Z M 896.94 206.77 L 910.31 206.78 L 910.31 198.97 C 910.32 196.41 907.19 194.15 903.63 194.15 L 903.62 194.15 C 900.07 194.15 896.95 196.4 896.95 198.97 Z M 891.37 225.71 L 891.38 207.89 C 891.38 207.59 891.5 207.31 891.7 207.1 C 891.91 206.89 892.2 206.77 892.49 206.77 L 894.71 206.77 L 894.72 198.97 C 894.72 195.08 898.71 191.92 903.62 191.92 L 903.63 191.92 C 908.54 191.93 912.54 195.09 912.54 198.97 L 912.54 206.78 L 914.77 206.78 C 915.39 206.78 915.89 207.28 915.89 207.89 L 915.88 225.71 C 915.88 226.01 915.76 226.29 915.55 226.5 C 915.34 226.71 915.06 226.83 914.76 226.83 L 892.49 226.82 C 891.87 226.82 891.37 226.32 891.37 225.71 Z M 939.29 204.54 L 941.51 204.54 L 941.51 202.31 L 939.29 202.31 Z M 921.46 204.54 L 933.71 204.54 L 933.71 202.31 L 921.46 202.31 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 255,
      marginLeft: 917
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "IAM")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 917,
    y: 267,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "IAM")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 878 470 L 956 470 L 956 548 L 878 548 Z",
    fill: "#dd344c",
    stroke: "none",
    pointerEvents: "all"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 935.94 532.4 C 935.94 530.59 934.41 529.06 932.6 529.06 C 930.79 529.06 929.26 530.59 929.26 532.4 C 929.26 534.21 930.79 535.74 932.6 535.74 C 934.41 535.74 935.94 534.21 935.94 532.4 Z M 917 531.29 C 915.19 531.29 913.66 532.82 913.66 534.63 C 913.66 536.44 915.19 537.97 917 537.97 C 918.81 537.97 920.34 536.44 920.34 534.63 C 920.34 532.82 918.81 531.29 917 531.29 Z M 901.4 529.06 C 899.59 529.06 898.06 530.59 898.06 532.4 C 898.06 534.21 899.59 535.74 901.4 535.74 C 903.21 535.74 904.74 534.21 904.74 532.4 C 904.74 530.59 903.21 529.06 901.4 529.06 Z M 904.3 512.34 L 929.7 512.34 L 921.17 504.67 L 917.72 507.62 C 917.52 507.8 917.26 507.88 917 507.88 C 916.74 507.88 916.48 507.8 916.27 507.62 L 912.83 504.67 Z M 902.51 495.82 L 902.51 510.96 L 911.13 503.2 Z M 929.59 494.51 L 904.41 494.51 L 917 505.3 Z M 931.49 510.96 L 931.49 495.82 L 922.87 503.2 Z M 938.17 532.4 C 938.17 535.42 935.62 537.97 932.6 537.97 C 929.58 537.97 927.03 535.42 927.03 532.4 C 927.03 529.76 928.98 527.48 931.49 526.95 L 931.49 523.49 L 918.11 523.49 L 918.11 529.18 C 920.62 529.71 922.57 531.99 922.57 534.63 C 922.57 537.65 920.02 540.2 917 540.2 C 913.98 540.2 911.43 537.65 911.43 534.63 C 911.43 531.99 913.38 529.71 915.89 529.18 L 915.89 523.49 L 902.51 523.49 L 902.51 526.95 C 905.02 527.48 906.97 529.76 906.97 532.4 C 906.97 535.42 904.42 537.97 901.4 537.97 C 898.38 537.97 895.83 535.42 895.83 532.4 C 895.83 529.76 897.78 527.48 900.29 526.95 L 900.29 522.37 C 900.29 521.76 900.78 521.26 901.4 521.26 L 915.89 521.26 L 915.89 514.57 L 901.4 514.57 C 900.78 514.57 900.29 514.07 900.29 513.46 L 900.29 493.4 C 900.29 492.78 900.78 492.28 901.4 492.28 L 932.6 492.28 C 933.22 492.28 933.71 492.78 933.71 493.4 L 933.71 513.46 C 933.71 514.07 933.22 514.57 932.6 514.57 L 918.11 514.57 L 918.11 521.26 L 932.6 521.26 C 933.22 521.26 933.71 521.76 933.71 522.37 L 933.71 526.95 C 936.22 527.48 938.17 529.76 938.17 532.4 Z M 948.2 509 C 948.2 515.58 946.17 521.88 942.32 527.21 L 940.52 525.91 C 944.08 520.96 945.97 515.11 945.97 509 C 945.97 493.03 932.98 480.03 917 480.03 C 901.03 480.03 888.03 493.03 888.03 509 C 888.03 515.11 889.92 520.96 893.48 525.91 L 891.68 527.21 C 887.83 521.88 885.8 515.58 885.8 509 C 885.8 491.8 899.8 477.8 917 477.8 C 934.2 477.8 948.2 491.8 948.2 509 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 555,
      marginLeft: 917
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon SES")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 917,
    y: 567,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon SES")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 368 360.5 L 446 360.5 L 446 438.5 L 368 438.5 Z",
    fill: "#8c4fff",
    stroke: "none",
    pointerEvents: "all"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 423.85 413.01 C 423.85 411.17 422.35 409.67 420.51 409.67 C 418.66 409.67 417.16 411.17 417.16 413.01 C 417.16 414.85 418.66 416.35 420.51 416.35 C 422.35 416.35 423.85 414.85 423.85 413.01 Z M 426.08 413.01 C 426.08 416.08 423.58 418.58 420.51 418.58 C 417.44 418.58 414.94 416.08 414.94 413.01 C 414.94 409.94 417.44 407.44 420.51 407.44 C 423.58 407.44 426.08 409.94 426.08 413.01 Z M 396.29 396.93 C 396.29 395.09 394.79 393.59 392.95 393.59 C 391.11 393.59 389.61 395.09 389.61 396.93 C 389.61 398.77 391.11 400.27 392.95 400.27 C 394.79 400.27 396.29 398.77 396.29 396.93 Z M 398.52 396.93 C 398.52 400 396.02 402.5 392.95 402.5 C 389.88 402.5 387.38 400 387.38 396.93 C 387.38 393.86 389.88 391.36 392.95 391.36 C 396.02 391.36 398.52 393.86 398.52 396.93 Z M 406.7 379.45 C 406.7 381.29 408.2 382.79 410.04 382.79 C 411.89 382.79 413.38 381.29 413.38 379.45 C 413.38 377.61 411.89 376.11 410.04 376.11 C 408.2 376.11 406.7 377.61 406.7 379.45 Z M 404.47 379.45 C 404.47 376.38 406.97 373.88 410.04 373.88 C 413.11 373.88 415.61 376.38 415.61 379.45 C 415.61 382.52 413.11 385.02 410.04 385.02 C 406.97 385.02 404.47 382.52 404.47 379.45 Z M 435.97 399.5 C 435.97 389.17 430.43 379.61 421.5 374.44 C 419.9 374.76 418.35 375.2 416.42 375.9 L 415.66 373.81 C 416.67 373.44 417.57 373.15 418.44 372.9 C 414.85 371.35 410.95 370.53 407 370.53 C 405.12 370.53 403.27 370.72 401.46 371.08 C 402.77 371.84 403.93 372.61 405.06 373.46 L 403.71 375.24 C 402.12 374.03 400.47 373.01 398.31 371.88 C 387.36 375.32 379.48 384.97 378.23 396.3 C 380.53 395.84 382.73 395.58 385.18 395.52 L 385.23 397.75 C 382.67 397.81 380.47 398.08 378.06 398.61 C 378.05 398.91 378.03 399.21 378.03 399.5 C 378.03 409.15 382.8 418.04 390.65 423.4 C 389.25 419.24 388.56 415.31 388.56 411.47 C 388.56 409.29 388.94 407.49 389.33 405.59 C 389.43 405.15 389.52 404.7 389.61 404.23 L 391.8 404.66 C 391.7 405.14 391.61 405.6 391.51 406.04 C 391.12 407.91 390.79 409.52 390.79 411.47 C 390.79 415.83 391.74 420.33 393.69 425.22 C 397.83 427.37 402.31 428.47 407 428.47 C 410.07 428.47 413.07 427.98 415.93 427.04 C 417.05 424.82 417.88 422.74 418.58 420.34 L 420.72 420.96 C 420.21 422.71 419.63 424.3 418.93 425.88 C 420.73 425.07 422.43 424.07 424.03 422.91 C 423.65 421.96 423.23 421.03 422.78 420.11 L 424.77 419.12 C 425.16 419.89 425.51 420.68 425.85 421.48 C 432.3 415.96 435.97 408.04 435.97 399.5 Z M 438.2 399.5 C 438.2 409.22 433.78 418.22 426.08 424.18 C 424.17 425.66 422.1 426.89 419.91 427.88 C 418.99 428.3 418.04 428.69 417.07 429.02 C 413.86 430.14 410.47 430.7 407 430.7 C 401.87 430.7 396.78 429.42 392.28 427.01 C 382.11 421.57 375.8 411.03 375.8 399.5 C 375.8 398.74 375.82 398.15 375.87 397.62 C 376.62 384.6 385.56 373.33 398.09 369.6 C 400.94 368.74 403.94 368.3 407 368.3 C 412.36 368.3 417.63 369.68 422.25 372.29 C 432.09 377.8 438.2 388.23 438.2 399.5 Z M 404.01 383.3 L 402.54 381.62 C 400.04 383.8 398.1 386.12 395.83 389.61 L 397.7 390.83 C 399.85 387.51 401.68 385.34 404.01 383.3 Z M 400.62 397.75 L 399.9 399.85 C 405.01 401.61 409.48 404.42 413.95 408.68 L 415.49 407.06 C 410.78 402.57 406.05 399.61 400.62 397.75 Z M 415.52 384.64 C 419.7 391.02 422.06 398.02 422.52 405.45 L 420.29 405.59 C 419.85 398.55 417.62 391.91 413.66 385.87 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 446,
      marginLeft: 407
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon CloudFront")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 407,
    y: 458,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Amazon CloudF...")))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 407 360.5 L 407 299 L 521.63 299",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 526.88 299 L 519.88 302.5 L 521.63 299 L 519.88 295.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 407 438.5 L 407 509 L 521.63 509",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 526.88 509 L 519.88 512.5 L 521.63 509 L 519.88 505.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 501,
      marginLeft: 649
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font3 || (_font3 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "send a message")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 649,
    y: 504,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "send a message")))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 776 509 L 871.63 509",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 876.88 509 L 869.88 512.5 L 871.63 509 L 869.88 505.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 501,
      marginLeft: 817
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font4 || (_font4 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "send message")))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 817,
    y: 504,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "send message")))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 47 258 L 47 311.6 L 47 358.75",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 47 364 L 43.5 357 L 47 358.75 L 50.5 357 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 180,
    width: 78,
    height: 78,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.22 192.92 C 55.22 187.75 59.5 183.55 64.76 183.55 C 70.02 183.55 74.29 187.75 74.29 192.92 C 74.29 198.08 70.02 202.29 64.76 202.29 C 59.5 202.29 55.22 198.08 55.22 192.92 Z M 75.65 205.41 C 74.51 204.7 73.29 204.11 72.05 203.64 C 75.54 201.31 77.84 197.38 77.84 192.92 C 77.84 185.8 71.97 180 64.76 180 C 57.55 180 51.68 185.8 51.68 192.92 C 51.68 197.37 53.97 201.3 57.45 203.62 C 55.18 204.48 53.05 205.73 51.16 207.34 L 53.47 210.04 C 56.63 207.32 60.63 205.83 64.73 205.83 C 67.92 205.83 71.05 206.73 73.78 208.42 C 78.64 211.44 81.83 216.74 82.37 222.55 L 64.73 222.55 L 64.73 226.09 L 84.23 226.09 C 85.21 226.09 86 225.3 86 224.32 C 86 216.62 82.04 209.37 75.65 205.41 Z M 19.77 192.92 C 19.77 187.75 24.05 183.55 29.31 183.55 C 34.56 183.55 38.84 187.75 38.84 192.92 C 38.84 198.08 34.56 202.29 29.31 202.29 C 24.05 202.29 19.77 198.08 19.77 192.92 Z M 29.27 222.55 L 11.63 222.55 C 12.49 213.18 20.07 205.83 29.27 205.83 C 32.47 205.83 35.6 206.73 38.33 208.42 C 39.1 208.9 39.83 209.44 40.53 210.04 L 42.84 207.35 C 42.01 206.63 41.12 205.98 40.2 205.41 C 39.05 204.7 37.84 204.11 36.59 203.64 C 40.08 201.31 42.39 197.38 42.39 192.92 C 42.39 185.8 36.52 180 29.31 180 C 22.09 180 16.22 185.8 16.22 192.92 C 16.22 197.37 18.52 201.31 22.02 203.63 C 13.85 206.72 8 214.81 8 224.32 C 8 225.3 8.79 226.09 9.77 226.09 L 29.27 226.09 Z M 29.35 254.45 C 30.21 245.09 37.8 237.74 47 237.74 C 50.19 237.74 53.33 238.64 56.06 240.33 C 60.91 243.35 64.1 248.65 64.64 254.45 Z M 37.5 224.83 C 37.5 219.66 41.77 215.45 47.03 215.45 C 52.29 215.45 56.57 219.66 56.57 224.83 C 56.57 229.99 52.29 234.2 47.03 234.2 C 41.77 234.2 37.5 229.99 37.5 224.83 Z M 57.93 237.32 C 56.78 236.61 55.57 236.02 54.32 235.54 C 57.81 233.22 60.11 229.29 60.11 224.83 C 60.11 217.7 54.25 211.91 47.03 211.91 C 39.82 211.91 33.95 217.7 33.95 224.83 C 33.95 229.28 36.25 233.22 39.74 235.54 C 31.58 238.63 25.73 246.72 25.73 256.23 C 25.73 257.21 26.52 258 27.5 258 L 66.5 258 C 67.48 258 68.27 257.21 68.27 256.23 C 68.27 248.53 64.31 241.28 57.93 237.32 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 47
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Users")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 277,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Users")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.26,
    y: 365,
    width: 94.52,
    height: 69,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.73 365.12 C 48.19 365.12 46.92 366.39 46.92 367.93 L 46.92 387.51 L 48.81 387.51 L 48.81 367.93 C 48.81 367.4 49.2 367.01 49.73 367.01 L 83.73 367.01 C 84.25 367.01 84.65 367.4 84.65 367.93 L 84.65 394.37 L 86.53 394.37 L 86.53 367.93 C 86.53 366.39 85.26 365.12 83.73 365.12 Z M 52.77 368.56 C 51.43 368.56 50.31 369.67 50.31 371.02 L 50.31 387.51 L 52.2 387.51 L 52.2 371.02 C 52.2 370.68 52.44 370.44 52.77 370.44 L 80.6 370.44 C 80.93 370.44 81.17 370.68 81.17 371.02 L 81.17 394.37 L 83.06 394.37 L 83.06 371.02 C 83.06 369.67 81.95 368.56 80.6 368.56 Z M 6.44 389.14 C 5.05 389.14 4.07 390.23 4.07 391.67 L 4.07 427.69 L 0.84 427.69 C 0.27 427.69 -0.01 428.09 -0.12 428.32 C -0.23 428.55 -0.26 428.74 -0.26 428.96 L -0.26 431.44 C -0.26 432.72 2.52 433.86 4.05 433.86 L 58.42 433.86 C 59.77 433.86 62.55 432.79 62.55 431.41 L 62.55 428.96 C 62.55 428.74 62.52 428.55 62.4 428.32 C 62.29 428.09 62.01 427.69 61.44 427.69 L 58.21 427.69 L 58.21 391.48 C 58.21 390.18 57.2 389.17 55.96 389.14 Z M 5.95 391.02 L 56.32 391.02 L 56.32 427.69 L 5.95 427.69 Z M 9.82 392.55 C 8.56 392.55 7.59 393.53 7.59 394.75 L 7.59 423.51 C 7.59 425.8 9.01 426.25 9.98 426.28 L 51.97 426.28 C 53.93 426.28 54.96 424.45 54.96 423.18 L 54.96 395.41 C 54.96 394.15 54.05 392.55 51.87 392.55 Z M 9.48 394.44 L 53.08 394.44 L 53.08 424.39 L 9.48 424.39 Z M 78.54 396.03 C 76.26 396.03 74.39 397.89 74.39 400.17 L 74.39 430.77 C 74.39 432.75 76.24 433.88 78.52 433.88 L 90.35 433.88 C 92.63 433.88 94.26 432.45 94.26 430.55 L 94.26 400.17 C 94.26 397.89 92.39 396.03 90.11 396.03 Z M 78.54 397.91 L 90.11 397.91 C 91.38 397.91 92.37 398.9 92.37 400.17 L 92.37 402.89 L 76.28 402.89 L 76.28 400.17 C 76.28 398.9 77.27 397.91 78.54 397.91 Z M 83.83 399.45 L 83.83 401.34 L 88.16 401.34 L 88.16 399.45 Z M 82.15 399.47 C 81.65 399.47 81.24 399.88 81.24 400.38 C 81.24 400.88 81.65 401.28 82.15 401.28 C 82.65 401.28 83.05 400.88 83.05 400.38 C 83.06 399.88 82.65 399.47 82.15 399.47 Z M 76.28 404.78 L 92.37 404.78 L 92.37 427.69 L 76.28 427.69 Z M 59.83 408.07 L 59.83 409.96 L 72.66 409.96 L 72.71 408.07 Z M 66.33 410.5 C 64.62 410.5 63.21 411.91 63.21 413.62 C 63.21 415.34 64.62 416.74 66.33 416.74 C 68.04 416.74 69.45 415.34 69.45 413.62 C 69.45 411.91 68.04 410.5 66.33 410.5 Z M 66.33 412.39 C 67.02 412.39 67.56 412.93 67.56 413.62 C 67.56 414.32 67.02 414.86 66.33 414.86 C 65.64 414.86 65.09 414.32 65.09 413.62 C 65.09 412.93 65.64 412.39 66.33 412.39 Z M 59.83 417.4 L 59.83 419.29 L 72.72 419.29 L 72.72 417.4 Z M 1.63 429.58 L 60.66 429.58 L 60.66 430.97 C 60.66 431.56 59.89 431.97 58.65 431.97 L 3.79 431.97 C 2.63 431.97 1.63 431.54 1.63 430.97 Z M 76.28 429.58 L 92.37 429.58 L 92.37 430.55 C 92.37 431.82 91.62 431.99 90.35 431.99 L 78.52 431.99 C 77.25 431.99 76.28 431.71 76.28 430.77 Z",
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 441,
      marginLeft: 47
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #545B64; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(84, 91, 100)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Devices")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 453,
    fill: "#545B64",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Devices")))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 267.5 409.2 L 267.5 412.98 C 267.5 419.99 259.84 426.5 251.71 426.5 L 204.05 426.5 C 196.11 426.5 188.02 420.37 188.02 412.87 L 188 410.07 C 188 403.3 191.87 397.01 198.29 394.86 C 198.12 389.1 200.32 383.97 204.39 379.71 C 209.79 374.17 218.31 372.5 225.43 375.07 C 230.91 377.09 235.06 381.17 237.12 385.93 C 240.76 383.5 245.35 383.41 249.15 386.22 C 251.18 387.73 253.06 390.31 253.24 394.13 C 256.94 394.47 260.79 396.26 263.89 400.02 C 266.15 402.68 267.45 406.15 267.5 409.2 Z",
    fill: "#0050ef",
    stroke: "none",
    pointerEvents: "all"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 267.5 409.2 L 267.5 412.98 C 267.5 420 259.84 426.5 251.71 426.5 L 204.05 426.5 C 196.08 426.5 188.02 420.37 188.02 412.87 L 188 410.07 C 188 417.45 195.87 423.63 203.96 423.63 L 251.51 423.63 C 260.45 423.63 267.5 416.96 267.5 409.2 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 372.5,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "#001dbc",
    pointerEvents: "all"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 226.07 410.01 L 219.31 410.01 L 219.31 419.32 L 210.27 419.32 L 210.27 410.01 L 203.54 410.01 L 214.8 390.28 Z M 237.33 419.24 L 226.07 399.5 L 232.8 399.5 L 232.8 390.19 L 241.84 390.19 L 241.84 399.5 L 248.6 399.5 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 434,
      marginLeft: 228
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font5 || (_font5 = /*#__PURE__*/React.createElement("font", {
    color: "#232f3e"
  }, "Public Internet")))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 446,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Public Intern...")))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 94.26 399.5 L 181.63 399.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 186.88 399.5 L 179.88 403 L 181.63 399.5 L 179.88 396 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 218.21 373.85 L 218.2 220 L 318 220 L 318 219 L 361.63 219",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 366.88 219 L 359.88 222.5 L 361.63 219 L 359.88 215.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 359,
      marginLeft: 149
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font6 || (_font6 = /*#__PURE__*/React.createElement("font", {
    color: "#0000ff"
  }, "api.domenic-aws.info", /*#__PURE__*/React.createElement("br", null), "www.domenic-aws.info", /*#__PURE__*/React.createElement("br", null), "domenic-aws.info")))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 363,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "api.domenic-aws.info...")))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 267.5 399.5 L 361.63 399.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 366.88 399.5 L 359.88 403 L 361.63 399.5 L 359.88 396 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 917.1 78 C 894.09 78 878 59.25 878 39.3 C 878 15.44 897.21 0 917.39 0 C 936.82 0 956 15.95 956 38.98 C 956 59.63 939.58 78 917.1 78 Z",
    fill: "#0d2636",
    stroke: "none",
    pointerEvents: "all"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 908.66 69.46 C 908.66 71.15 907.38 71.84 905.47 71.19 C 893.92 67.14 882.83 54.65 882.83 39.05 C 882.83 17.95 900.88 4.65 916.52 4.65 C 936.82 4.65 951.26 21.29 951.26 38.85 C 951.26 53.34 941.94 66.68 927.96 71.36 C 926.39 71.78 925.41 70.94 925.41 69.55 L 925.41 59.4 C 925.41 57.43 924.6 55.34 923.13 53.88 C 928.8 53.23 932.24 51.82 934.88 49.1 C 937.47 46.53 938.63 42.76 938.85 38.1 C 938.99 34.39 938 30.78 935.32 28.03 C 936.26 25.76 936.41 22.75 935 19.02 C 932.19 18.8 928.99 20.49 925.71 22.52 C 919.95 21.02 914.2 20.82 908.44 22.6 C 905.86 20.93 903.52 19.04 899.06 19.02 C 897.88 22.31 897.7 25.31 898.71 27.97 C 895.52 31.51 895.16 34.99 895.21 38.45 C 895.57 45.13 898.01 48.51 900.72 50.52 C 902.98 52.2 906.14 53.24 910.96 53.95 C 909.67 55.23 908.94 56.76 908.82 58.55 C 905.99 59.84 901.93 60.49 899.16 56.56 C 897.92 54.58 896.23 52.35 893.02 52.36 C 892.49 52.34 891.98 52.55 891.9 52.78 C 891.83 53.03 892.12 53.55 892.48 53.75 C 895.29 55.54 895.74 56.54 896.89 58.99 C 897.95 61.84 899.8 62.94 901.8 63.71 C 903.84 64.43 907.14 64.23 908.66 63.71 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 85,
      marginLeft: 917
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font7 || (_font7 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "Github")))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 917,
    y: 97,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Github")))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 734.19 1.25 C 735.86 0 738.14 0 739.81 1.25 L 774.83 36.38 C 776 38.02 776 40.23 774.83 41.87 L 740.51 76.53 C 739.63 77.47 738.4 78 737.12 78 C 735.83 78 734.61 77.47 733.72 76.53 L 699.17 41.87 C 698 40.23 698 38.02 699.17 36.38 L 723.04 12.47 L 731.62 21.02 C 730.54 24.15 732.08 27.59 735.13 28.86 L 735.13 50.19 C 732.6 51.32 731.21 54.07 731.78 56.78 C 732.36 59.5 734.74 61.44 737.51 61.44 C 740.27 61.44 742.66 59.5 743.23 56.78 C 743.8 54.07 742.41 51.32 739.89 50.19 L 739.89 29.33 L 747.92 37.48 C 746.91 40.06 747.83 43 750.13 44.53 C 752.43 46.07 755.48 45.78 757.45 43.84 C 759.43 41.9 759.78 38.84 758.31 36.5 C 756.84 34.15 753.94 33.16 751.35 34.11 L 742.77 25.49 C 743.61 23.31 743.09 20.85 741.45 19.21 C 739.81 17.56 737.37 17.04 735.21 17.88 L 726.39 9.17 Z",
    fill: "#ff9933",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 85,
      marginLeft: 737
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font8 || (_font8 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "Repository")))))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 97,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Repository")))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 698 39 L 567 39 L 567 253.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 567 258.88 L 563.5 251.88 L 567 253.63 L 570.5 251.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 161,
      marginLeft: 568
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font9 || (_font9 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "AWS S3 sync build")))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 568,
    y: 164,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "AWS S3 sync build")))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 878 39 L 782.37 39",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 777.12 39 L 784.12 35.5 L 782.37 39 L 784.12 42.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 51,
      marginLeft: 830
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FEFAE0; background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(254, 250, 224)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, _font10 || (_font10 = /*#__PURE__*/React.createElement("font", {
    color: "#000000"
  }, "ReactJS project")))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 54,
    fill: "#FEFAE0",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "ReactJS project"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.b07eff1a529f089e2197d7ab353a9676.svg";
export { ForwardRef as ReactComponent };